export default __webpack_public_path__ + "static/media/matchmaker-radio-on.1d49a673.svg";